<template>
  <section>
    <div class="popups">
      <b-sidebar
        v-model="showFilters"
        right
        shadow
        backdrop
        bg-variant="white"
        no-header
      >
        <template>
          <div class="container sidebar-header">
            <b-row>
              <div class="col">
                <b-button
                  variant="primary"
                  @click="
                    applyFilters();
                    loadItems();
                    showFilters = false;
                  "
                  >Apply</b-button
                >
              </div>
              <div class="col-auto text-right">
                <b-button
                  type="reset"
                  variant="outline-danger"
                  @click="resetFormFilters()"
                >
                  Reset
                </b-button>
                <b-button
                  variant="outline-secondary"
                  class="ml-1"
                  @click="
                    showFilters = false;
                    formFilters = { ...itemsFilters };
                  "
                >
                  Cancel
                </b-button>
              </div>
            </b-row>
          </div>

          <div class="px-3 py-2">
            <b-form-group label="Storefront:">
              <b-v-select
                v-model="formFilters.projectId"
                :searchable="true"
                :options="projectsFilter"
              />
            </b-form-group>
          </div>
        </template>
      </b-sidebar>
    </div>

    <div class="header">
      <div class="header-body">
        <div class="row align-items-end">
          <h6 class="col-12 header-pretitle">
            Product Mappings
          </h6>
          <div class="col">
            <b-button-group class="mb-1">
              <b-button
                variant="outline-primary"
                :to="{ name: 'Storefronts.ProductMappings.Index' }"
                tag="router-link"
              >
                Active
              </b-button>
              <b-button variant="secondary" disabled>
                Requests
                <span v-if="tableOptions.totalRows > 0" class="badge badge-light ml-1">
                  {{ tableOptions.totalRows }}
                </span>
              </b-button>
            </b-button-group>
            <ActiveFiltersCard
              :itemsFilters="itemsFilters"
              :resetFilterWithKey="resetFilterWithKey"
              :loadItems="loadItems"
            >
              <template v-slot:filterVal(projectId)="data">
                <span v-if="myProjects && myProjects.find(a => a.id == data.item)">
                  {{ myProjects.find(a => a.id == data.item).name }}
                </span>
                <span v-else>-</span>
              </template>
            </ActiveFiltersCard>
          </div>
          <div class="col-auto">
            <b-button variant="primary" @click="showFilters = !showFilters">
              <i class="fa fa-filter mr-2"></i>
              Filters
            </b-button>
          </div>
        </div>
      </div>
    </div>

    <TableListing
      class="mb-0"
      :loading-page="loadingItems"
      :failed-loading="failedLoadItems"
      head-variant="dark"
      :items.sync="items"
      :fields.sync="fields"
      :pagination.sync="pagination"
      :options.sync="tableOptions"
      v-on:pagination-changed="loadItems"
    >
      <template v-slot:cell(storefront)="data">
        <span v-if="myProjects && data.item.product && myProjects.find(a => a.id == data.item.product.projectId)">
          {{ myProjects.find(a => a.id == data.item.product.projectId).name }}
        </span>
        <span v-else>-</span>
      </template>
      <template v-slot:cell(sku)="data">
        <span v-if="data.item.product">{{ data.item.product.sku }}</span>
      </template>
      <template v-slot:cell(wmsItem)="data">
        <span v-if="data.item.wmsProduct">{{ data.item.wmsProduct.item }}</span>
        <span v-else>-</span>
      </template>
      <template v-slot:cell(action)="data">
        <span v-if="data.item.action === 'Create'" class="badge badge-success">Create</span>
        <span v-else-if="data.item.action === 'Remove'" class="badge badge-danger">Remove</span>
        <span v-else-if="data.item.action === 'Update'" class="badge badge-info">Update</span>
        <span v-else class="badge badge-secondary">{{ data.item.action }}</span>
      </template>
      <template v-slot:cell(quantity)="data">
        <span>{{ data.item.quantity }}</span>
      </template>
      <template v-slot:cell(notes)="data">
        <span v-if="data.item.notes">{{ data.item.notes }}</span>
        <span v-else class="text-muted">-</span>
      </template>
      <template v-slot:cell(addedByUserName)="data">
        <span v-if="data.item.addedByUserName">{{ data.item.addedByUserName }}</span>
        <span v-else class="text-muted">-</span>
      </template>
      <template v-slot:cell(approvedByUserName)="data">
        <span v-if="data.item.approvedByUserName">{{ data.item.approvedByUserName }}</span>
        <span v-else class="text-muted">-</span>
      </template>
      <template v-slot:cell(createDateTimeUtc)="data">
        <span>{{ data.item.createDateTimeUtc | moment('MMM Do YY, h:mm a') }}</span>
      </template>
      <template v-slot:cell(actions)="data">
        <b-button
          variant="success"
          size="sm"
          class="mr-1"
          :disabled="approvingId === data.item.id || denyingId === data.item.id"
          @click="ApproveRequest(data.item)"
        >
          <i v-if="approvingId === data.item.id" class="fa fa-spinner fa-spin mr-1"></i>
          Approve
        </b-button>
        <b-button
          variant="danger"
          size="sm"
          :disabled="approvingId === data.item.id || denyingId === data.item.id"
          @click="DenyRequest(data.item)"
        >
          <i v-if="denyingId === data.item.id" class="fa fa-spinner fa-spin mr-1"></i>
          Deny
        </b-button>
      </template>
    </TableListing>
  </section>
</template>

<script>
import ActiveFiltersCard from '@/views/components/ActiveFiltersCard.vue';
import TableListing from '@/views/components/TableListing.vue';
import { crudMixinGen, myCommonDataMixin } from '@/helpers/utils/vueMixins.js';

export default {
  name: 'Storefronts.ProductMappingRequests.Index',
  mixins: [crudMixinGen('productMappingRequests'), myCommonDataMixin],
  components: {
    TableListing,
    ActiveFiltersCard
  },

  data: function() {
    return {
      approvingId: null,
      denyingId: null,
      fields: [
        { key: 'storefront', label: 'Storefront', sortable: false },
        { key: 'sku', label: 'SKU', sortable: false },
        { key: 'wmsItem', label: 'WMS Item', sortable: false },
        { key: 'action', label: 'Action', sortable: false },
        { key: 'quantity', label: 'Qty', sortable: false },
        { key: 'notes', label: 'Notes', sortable: false },
        { key: 'addedByUserName', label: 'Requested By', sortable: false },
        { key: 'approvedByUserName', label: 'Approved By', sortable: false },
        { key: 'createDateTimeUtc', label: 'Requested At', sortable: false },
        { key: 'actions', label: 'Actions', sortable: false }
      ]
    };
  },

  mounted: function() {
    this.loadItems();
  },

  methods: {
    ApproveRequest: function(item) {
      var $this = this;
      $this.approvingId = item.id;
      $this.$http
        .post('/api/common/productMappingRequests/' + item.id + '/approve')
        .then(function(resp) {
          if (resp.data && resp.data.success) {
            $this.$swal('Approved', 'Mapping request approved successfully.', 'success');
            $this.loadItems();
          } else {
            $this.$swal('Error', (resp.data && resp.data.errorMessage) || 'Failed to approve request.', 'error');
          }
        })
        .catch(function(err) {
          var msg = (err.response && err.response.data && err.response.data.errorMessage) || 'Failed to approve request.';
          $this.$swal('Error', msg, 'error');
        })
        .finally(function() {
          $this.approvingId = null;
        });
    },

    DenyRequest: function(item) {
      var $this = this;
      $this.$swal({
        title: 'Deny this request?',
        text: 'This will permanently delete the mapping request.',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#d33',
        cancelButtonColor: '#6c757d',
        confirmButtonText: 'Yes, deny it'
      }).then(function(result) {
        if (result.value) {
          $this.denyingId = item.id;
          $this.$http
            .delete('/api/common/productMappingRequests/' + item.id)
            .then(function(resp) {
              $this.$swal('Denied', 'Mapping request has been denied.', 'success');
              $this.loadItems();
            })
            .catch(function(err) {
              var msg = (err.response && err.response.data && err.response.data.errorMessage) || 'Failed to deny request.';
              $this.$swal('Error', msg, 'error');
            })
            .finally(function() {
              $this.denyingId = null;
            });
        }
      });
    }
  }
};
</script>
